module.exports = {
  FEEDBACK_GET: '/mocks/feedback-api/feedback.json',
  REGISTER_SOFTWARE: '/mocks/feedback-api/register-software.json',
  RETRIEVE_PASSWORD: '/mocks/feedback-api/retrieve-password.json',
  FEEDBACK_SEND: '/mocks/feedback-api/feedback.json?{survey_id}',
  FEEDBACK_UPDATE: '/mocks/feedback-api/feedback.json?{survey_id}&{response_id}',
  PRODUCTS_DETAILS: '/mocks/product-api/serial-{serial}.json',
  SCHEMATICS_LIST: '/mocks/product-api/schematics/schematics.json?serial={serial}',
  SCHEMATICS_DETAILS: '/mocks/product-api/schematics/details.json?serial={serial}',
  SERVICE_LIBRARY_DOCUMENTS: '/mocks/product-api/documents/documents-list.json?serial={serial}',
  SERVICE_LIBRARY_DOCUMENT_DOWNLOAD: '/mocks/product-api/documents/document.json?serial={serial}',
  SERVICE_LIBRARY_MANUALS: '/mocks/product-api/documents/manuals.json?serial={serial}',
  BULLETIN_DETAILS: '/mocks/product-api/documents/bulletin.json?serial={serial}',
  TRANSLATIONS: '/mocks/content-api/{path}.json',
  DP_CONCEPTS: '/mocks/content-api/{path}.json',
  SITEMAP: '/mocks/sitemap.json',
  SAFETY_DOCS: '/mocks/safetydocs.json',
  OPTIONS_LIST: '/mocks/equipment-api/options/options-{serial}.json',
  TROUBLESHOOTING_GUIDES_LIST: '/mocks/product-api/troubleshooting/guides_{serial}.json',
  TROUBLESHOOTING_TOP_GUIDES_LIST: '/mocks/product-api/troubleshooting/guides_{serial}_top.json',
  TROUBLESHOOTING_SESSION_LIST: '/mocks/product-api/troubleshooting/sessions.json?serial={serial}',
  TROUBLESHOOTING_SESSION_START: '/mocks/product-api/troubleshooting/session-start.json?serial={serial}',
  TROUBLESHOOTING_SESSION_RESUME: '/mocks/product-api/troubleshooting/session-start.json?session_id={session_id}',
  TROUBLESHOOTING_SESSION_SUMMARY: '/mocks/product-api/troubleshooting/session-summary.json?serial={serial}',
  FAULT_CODES_LIST: '/mocks/iot-api/faultcodes/{serial}.json',
  MACHINE_DATA: '/mocks/iot-api/serial-{serial}.json',
  PRODUCT_PASSWORD: '/mocks/product-api/password/{serial}.json',
  PRODUCT_PASSWORD_UPDATE: '/mocks/product-api/password/{serial}.json?{panel}',
  SERVICE_FIELD_MODIFICATIONS: '/mocks/equipment-api/field_modifications.json?serial_number={serial}',
  LOCATION_DATA: '/mocks/iot-api/location/{serial}.json',
  SERVICE_LIBRARY_LETTERS: '/mocks/product-api/documents/service_letters.json?field_mod_code={field_mod_code}',
  SERVICE_MAINTENANCE_DETAILS: '/mocks/product-api/service-details.json?serial={serial}',
  FAULT_CODES_AUTOCOMPLETE: '/mocks/product-api/faultCodes/{code_prefix}.json',
  WARRANTY_PLANS: '/mocks/equipment-api/warranty/plans.json?serial={serial}',
  WARRANTY_INCLUSIONS: '/mocks/equipment-api/warranty/warranty_inclusions.json?serial={serial}',
  WARRANTY_ARTICLES: '/mocks/equipment-api/warranty/articles.json?region=na&language={language}',
  MACHINE_SOFTWARE: '/mocks/product-api/software/{serial}.json',
  ACCOUNT_SUBSCRIPTION: '/mocks/asset-api/{account}.{serial}.json',
  LATEST_SOFTWARE: '/mocks/dp-api/{software}.json',
  ACTIVE_NOTIFICATIONS: '/mocks/announcements/active/app/{appId}?regionCodes=NA',
  FEATURE_FLAG: '/mocks/product-api/feature-flags.json?serialNumber={serial}'
}
